class AgTestimonials extends HTMLElement {
  constructor() {
    super();
    this.track = null;
    this.items = [];
    this.dots = [];
    this.observer = null;
    this.currentIndex = 0;
  }

  connectedCallback() {
    this.track = this.querySelector('.ag-testimonials__track');
    this.items = [...this.querySelectorAll('.ag-testimonials__card')];
    this.dots = [...this.querySelectorAll('.ag-testimonials__dot')];

    if (!this.track || this.items.length < 2) return;

    this.initObserver();
    this.initDots();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  initObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const index = this.items.indexOf(entry.target);
            if (index !== -1) this.setActive(index);
          }
        }
      },
      { root: this.track, threshold: 0.5 }
    );

    for (const item of this.items) {
      this.observer.observe(item);
    }
  }

  initDots() {
    for (const dot of this.dots) {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index, 10);
        this.scrollTo(index);
      });
    }
  }

  setActive(index) {
    this.currentIndex = index;
    for (let i = 0; i < this.dots.length; i++) {
      this.dots[i].setAttribute('aria-current', i === index ? 'true' : 'false');
    }
  }

  scrollTo(index) {
    const target = this.items[index];
    if (!target) return;
    this.track.scrollTo({
      left: target.offsetLeft - this.track.offsetLeft,
      behavior: 'smooth',
    });
  }
}

if (!customElements.get('ag-testimonials')) {
  customElements.define('ag-testimonials', AgTestimonials);
}
